export const RestConfig = {
    DEFAULT_ROOT_PATH: "/",
    DEFAULT_CONTENT_TYPE: "application/json",
    RETRY_MAXTIME: 10,
    RETRY_TIME_SPAN: 3000,
    APPLICATIONS: [{
        key: "CGP",
        appName: "cgp-rest",
        isAuthorize: true,
        services: ["REST_SERVICE", "BUILDERCONFIG_SERVICE", "PRODUCTINSTANCE_SERVICE", "SIMPLIFYBOM_SERVICE", "PROPERTYMODEL_SERVICE", "PRODUCT_SERVICE", "TEMPLATECONFIGS_SERVICE", "NAVIGATION_SERVICE", "BUILDERVIEW_SERVICE", "CUSTOMIZATION_SERVICE", "THREED_SERVICE", "RESOURCE_LIBRARY_SERVICE", "BUILDER_RUNTIME_SERVICE", "PAGECONTENTS", "LANGUAGE_SERVICE","FILE_LIBRARY"]
    }, {
        key: "FILE",
        appName: "file",
        isAuthorize: false,
        services: ["FILE_SERVICE"]
    }
        , {
        key: "TEXT",
        appName: "text-service",
        isAuthorize: false,
        services: ["TEXT_SERVICE"]
    }],
    // 获取唯一标识ID
    "REST_SERVICE.KEY": {
        path: "api/common/key",
        isAuthorize: true
    },
    //文件服务
    "FILE_SERVICE.IMAGE_TRANSFORM": {
        path: "image",
        httpConfig: {
            method: "PUT"
        }
    },
    "FILE_SERVICE.UPLOAD": {
        path: "file/upload",
        actions: {
            upload: {
                method: "POST",
                headers: {
                    'Content-Type': undefined
                }
            }
        }
    },
    "FILE_SERVICE.UPLOAD_BASE64": {
        path: "file/upload/base64",
        httpConfig: {
            method: "POST"
        }
    },
    "FILE_SERVICE.UPLOAD_WITH_URL": {
        path: "file/uploadUrl",
        httpConfig: {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            }
        }
    },
    "FILE_SERVICE.FILE_STATIC": {
        path: "static",
    },
    "FILE_SERVICE.MODEL_MAPS_NAME": {
        path: "static/"
    },
    "FILE_SERVICE.FILE": {
        path: "file/"
    },
    "FILE_LIBRARY.FILE": {
        path: "api/file/"
    },
    "FILE_SERVICE.FONT_ICON": {
        path: "static/font/fontIcon/"
    },
    //builder重构新接口
    //获取NavigationRuntime
    "NAVIGATION_SERVICE.NAVIGATION_RUN_TIME": {
        path: "api/navigationRuntimes/:id",
        paramDefaults: {
            id: '@id'
        }
    },
    //获取BuilderViewRuntime
    "BUILDERVIEW_SERVICE.BUILDERVIEW_RUN_TIME": {
        path: "api/builderViewRuntimes/:id",
        paramDefaults: {
            id: '@id'
        }
    },
    //获取ProductInstance
    // "PRODUCTINSTANCE_SERVICE.GET_PRODUCTINSTANCE": {
    //     path: "api/productInstances/:idtype/:id/:language/latest/v3",
    //     testPath: "api/productInstances/:idtype/:id/:language/latest/test/v3",
    //     paramDefaults: {
    //         idtype: "@idtype",
    //         id: '@id',
    //         language: "@language",
    //     }
    // },
    //保存ProductInstance
    // "PRODUCTINSTANCE_SERVICE.PRODUCTINSTANCE": {
    //     path: "api/productInstances/"
    // },
    //changeProductInstance 通过PropertyModel获取ProductInstance
    "PRODUCTINSTANCE_SERVICE.CHANGE_PRODUCTINSTANCE": {
        path: "api/propertyModel/productInstance/latest",
        testPath: "api/propertyModel/productInstance/latest/test"
    },
    //获取、保存Customization
    "CUSTOMIZATION_SERVICE.CUSTOMIZATION": {
        path: "api/customizationRuntime/:sbomNodeRuntimeId",
        paramDefaults: {
            sbomNodeRuntimeId: "@sbomNodeRuntimeId",
        }
    },
    // 获取Builder文字列表  
    "BUILDERCONFIG_SERVICE.FONT_V2": {
        path: "api/builderConfigs/fonts/v2",
        paramDefaults: {
            propertyModelId: "@propertyModelId",
            languageCode: "@languageCode",
            regionCode: "@regionCode",
            platForm: "@platForm"
        }
    },
    "TEMPLATECONFIGS_SERVICE.TEMPLATE_FORMAT": {
        path: "api/materialView/:mvId/:groupId/formats",
        paramDefaults: {
            mvId: "@mvId",
            groupId: '@groupId',
        }
    },
    // 获取propertyModel
    "PROPERTYMODEL_SERVICE.ATTRIBUTE_PROPERTY": {
        path: "api/attributeProperty/:id",
        paramDefaults: {
            id: '@id'
        }
    },
    "PRODUCT_SERVICE.PRODUCT_AVAILABLE": {
        path: "api/products/available/:id/v2",
        paramDefaults: {
            id: '@id'
        }
    },
    // 计算propertyModel
    "PRODUCT_SERVICE.CALCULATEPROPERTYMODEL": {
        path: "api/attributeProperty/:productId/calculateModel"
    },
    "BUILDERCONFIG_SERVICE.FONT_COLOR": {
        path: "api/builderConfigs/:propertyModelId/fonts/colors",
        paramDefaults: {
            propertyModelId: "@propertyModelId",
        }
    },
    "TEXT_SERVICE.BUILDERTEXT_SERVICE": {
        path: "api/text/content"
    },
    "TEXT_SERVICE.BUILDERTEXT_SERVICE_V2": {
        path: "api/text/content/v2"
    },
    "BUILDERCONFIG_SERVICE.COLOR_LIBRARY": {
        path: "api/builderConfigs/:propertyModelId/bcackground/colors",
        paramDefaults: {
            propertyModelId: "@propertyModelId",
        }
    },
    //请求3D配置数据
    "THREED_SERVICE.MODEL_CONFIG": {
        path: "api/threeDModelRuntime/model/:modelId/latest",
        testPath: "api/threeDModelRuntime/model/:modelId/latest/test",
        paramDefaults: {
            modelId: "@modelId"
        }
    },
    //*3D模型配置数据
    "PRODUCT_SERVICE.THREED_MODEL_CONFIG_DOWNLOAD": {
        path: "api/threedmodelvariableconfigs/generateRuntimeModel/latest",
        testPath: "api/threedmodelvariableconfigs/generateRuntimeModel/latest/test"
    },
    //通过资源Item的Id数组
    "RESOURCE_LIBRARY_SERVICE.CLASSIFICATION_RESOURCE_ID": {
        path: "api/pcResourceLibItems",
        testPath: "api/pcResourceLibItems",
    },
    //获取指定business库的所有分类
    "RESOURCE_LIBRARY_SERVICE.BUSINESS_CLASSIFICATION": {
        path: "api/:name/:id/businessLibs/:libId/categories/latest",
        testPath: "api/:name/:id/businessLibs/:libId/categories/latest/test",
        paramDefaults: {
            name: "@name",
            id: "@id",
            libId: "@libId"
        }
    },
    //获取指定分类下的资源
    "RESOURCE_LIBRARY_SERVICE.CLASSIFICATION_RESOURCE": {
        path: "api/pcResourceLibs/:libId/categories/:categoryId/items",
        testPath: "api/pcResourceLibs/:libId/categories/:categoryId/items",
        paramDefaults: {
            categoryId: "@categoryId",
            libId: "@libId"
        }
    },
    //获取指定条件下的资源
    "RESOURCE_LIBRARY_SERVICE.CONDITION_RESOURCE": {
        path: "api/businessLibs/:businessType/effectTypes/:effectType/:resourceLevel/:id/pcResources/:languageCode/latest",
        testPath: "api/businessLibs/:businessType/effectTypes/:effectType/:resourceLevel/:id/pcResources/:languageCode/test",
        paramDefaults: {
            businessType: "@businessType",
            effectType: "@effectType",
            languageCode: "@languageCode",
            resourceLevel: "@resourceLevel",
            id: "@id"
        }
    },
    //获取值类型资源
    "RESOURCE_LIBRARY_SERVICE.SIMPLE_RESOURCE": {
        path: "api/simplePCResources/:id",
        testPath: "api/simplePCResources/:id",
        paramDefaults: {
            id: "@id",
        }
    },
    //获取指定尺寸的DynamicSizeImage或者CompositeDisplayObject
    "RESOURCE_LIBRARY_SERVICE.DYNAMICSIZE_COMPOSITE_RESOURCE": {
        path: "api/:type/:id/:width/:height",
        testPath: "api/:type/:id/:width/:height",
        paramDefaults: {
            type: "@type",
            id: "@id",
            width: "@width",
            height: "@height",
        }
    },
    "FILE_SERVICE.FILE_NAME": {
        path: "file/{name}"
    },
    "BUILDER_RUNTIME_SERVICE.INITIAL": {
        path: "api/navigationRuntimes/:navigationRuntimeId/builderViews/:builderViewRuntimeId",
        paramDefaults: {
            navigationRuntimeId: "@navigationRuntimeId",
            builderViewRuntimeId: "@builderViewRuntimeId",
        }
    },
    // "BUILDER_RUNTIME_SERVICE.NAVIGATION_CHANGE": {
    //     path: "api/navigationRuntimes/:navigationRuntimeId/items/:itemId/builderViews/:builderViewRuntimeId",
    //     paramDefaults: {
    //         navigationRuntimeId: "@navigationRuntimeId",
    //         itemId: "@itemId",
    //         builderViewRuntimeId: "@builderViewRuntimeId",
    //     }
    // },
    "PRODUCTINSTANCE_SERVICE.RTOBJECT": {
        path: "api/rtObjects"
    },
    "PAGECONTENTS.PREVIEW": {
        path: "api/pageContents/preview?format=:format&dpi=:dpi&convert2Base64=:convert2Base64&scale=:scale",
        paramDefaults: {
            format: "@format",
            dpi: "@dpi",
            convert2Base64: "@convert2Base64",
            scale: "@scale"
        }
    },
    "PAGECONTENT_CLAZZ": "com.qpp.cgp.domain.bom.runtime.PageContent",
    "LANGUAGE_SERVICE.VALUES": {
        path: "api/languageresources/:languageCode/values",
        paramDefaults: {
            languageCode: "@languageCode"
        }
    },
    "PAGECONTENTS.SEQUENCE": {
        path: "api/pageContents/sequences",
    },
    "FILE_SERVICE.PARSE": {
        path: "file/parser/"
    },
    "PAGECONTENTS.PARSE": {
        path: "api/files/"
    },
    // 获取 唯一标识列表
    "REST_SERVICE.KEY_LIST": {
        path: "common/keys?size=:size",
        paramDefaults: {
            size: "@size"
        }
    }
}